<template>
  <div class="healthcare-pro-tip">
    <div class="content">
      <div v-html="content"></div>
      <a
        v-if="!full && acf.full"
        href="#"
        class="btn cta-plain text-red icon down-arrow textButtonDark"
        v-on:click.prevent="full = true"
        >Read more</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "healthcare-pro-tip",
  props: ["acf"],
  data() {
    return {
      content: "",
      full: false,
    };
  },
  watch: {
    full(arg) {
      arg && (this.content = this.acf.full);
    },
  },
  created() {
    this.content = this.acf.excerpt;
  },
};
</script>

<style scoped lang="scss">
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/modal";

.healthcare-pro-tip {
  padding: 0 0 2rem 0;

  .content {
    position: relative;
    padding: 0.5rem 0 0.5rem 5rem;

    &:before {
      width: 4rem;
      height: 4rem;
      content: "";
      display: block;
      position: absolute;
      top: 0.5rem;
      left: 0;
      background-image: url(#{$assets}/images/illo-doctor-woman.svg);
      background-size: 5rem;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
}
</style>